import "./TrustedBackendHtml.css";

import { twResolve } from "@/helpers/tw-resolve";

interface TrustedBackendHtmlProps {
  html: string;
  title?: string;
  preview?: boolean;
}

/**
 * Trust boundary for HTML generated and stored by our backend rich-text flow.
 *
 * This adapter deliberately does not sanitize. Callers must only pass HTML from
 * that trusted backend source, never arbitrary user or third-party markup.
 */
export function TrustedBackendHtml({
  html,
  preview = false,
  ...nativeProps
}: TrustedBackendHtmlProps): React.ReactNode {
  return (
    <div
      {...nativeProps}
      className={twResolve("aop-cleanslate w-full [word-break:break-word]", preview && "line-clamp-4")}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
